<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'회원 등급'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; padding: 0 12px; overflow-y: scroll;">
            <div style="margin-top: 15px; display: flex; gap: 14px; justify-content: space-between;">
                <div style="margin-top: 24px;">
                    <div style="font-size: 20px; font-weight: 700;">{{ $GlobalStore.loginInfo().nic_name }}님,</div>
                    <div style="margin-top: 8px; font-weight: 700;">오늘도 훈련해볼까요?</div>
                    <div style="font-size: 12px; font-weight: 700; margin-top: 18px;"><span style="font-weight: 700; font-size: 20px;"> {{ totalPoint }}p</span> / 오늘 획득 포인트 {{ todayPoint }}p</div>
                    <div style="display: flex; margin-top: 17px; align-items: end;">
                        <div style="min-height: 57px; min-width: 57px;">
                            <img style="width: 57px;" :src="$resourcePath + myGradeImagePath" alt="">
                        </div>
                        <div style="font-weight: 700; ">{{ myGradeName }} <span style="font-size: 12px;">등급</span></div>
                    </div>
                </div>
                <div>
                    <img style="width: 157px;" :src="require('@/assets/img/soccer_man.png')" alt="">
                </div>
            </div>
            <div style="margin-top: 18px; background: linear-gradient(102.49deg, #FF8C21 1.61%, #FAC74D 98.43%); border-radius: 20px; padding: 14px;">
                <div style="margin-top: 10px; margin-left: 10px;">
                    <div style="font-weight: 700; font-size: 20px;">{{ monthNumber }}월 {{ weekString }} 주 출석 체크</div>
                    <div style="margin-top: 10px; font-weight: 500;">어플 접속 시 5p 자동 적립</div>
                </div>
                <div style="margin-top: 27px; display: flex; justify-content: space-between; margin-bottom: 2px;">
                    <div v-for="each, i in thisWeekAttendance" :key="i" class="common_box" :class="setBoxClass(each.isBeforeToday, each.isAttend)">
                        <div style="color: #fff; font-size: 12px; font-weight: 500; position: absolute; top: -18px;" v-if="today === each.date">Today</div>
                        <template v-if="thisWeekAttendance.length > 0">
                            <div style="padding-top: 8px;">
                                <img v-if="each.isAttend && each.isBeforeToday" style="width: 13px;" :src="require('@/assets/img/attendance.png')" alt="">
                                <img v-else-if="!each.isAttend && each.isBeforeToday" style="width: 13px;" :src="require('@/assets/img/absence.png')" alt="">
                                <img v-else-if="!each.isBeforeToday" style="width: 13px; opacity: 0;" :src="require('@/assets/img/absence.png')" alt="">
                            </div>
                            <div style="font-size: 12px; font-weight: 500; margin-top: 5px; line-height: 16px; color: #fff;">{{ each.day }}</div>
                            <div style="font-size: 12px; font-weight: 500; margin-top: 8px; line-height: 16px; color: #fff; padding-bottom: 16px; white-space: nowrap;">{{ each.date.split('-')[2] }}일</div>
                        </template>
                    </div>
                </div>
            </div>
            <div style="margin-top: 18px;">
                <div style="font-weight: 700;">적립 안내</div>
                <div style="">
                    <div :style="{borderBottom: i === accumulationList.length - 1 ? '' : '1px solid #f5f5f5'}" style="padding: 0 12px; padding-bottom: 15px; margin-top: 15px; border-bottom: 1px solid #f5f5f5; display: flex; align-items: center;" v-for="each, i in accumulationList" :key="i + 'accumulation'">
                        <div style="flex: 1; display: flex; align-items: center; gap: 10px;">
                            <div>
                                <img style="width: 60px;" :src="$resourcePath + each.image_path" alt="">
                            </div>
                            <div>
                                <div style="font-weight: 700; margin-bottom: 5px;">{{ each.description }}</div>
                                <div style="font-weight: 500; font-size: 12px; color: #808080; line-height: 16px;">{{ each.sub_description }}</div>
                            </div>
                        </div>
                        <div>
                            <div v-if="each.is_complete" style="width: 59px; height: 33px; border-radius: 27px; line-height: 33px; text-align: center; background-color: #210f03; color: var(--color-main); font-weight: 700;">완료</div>
                            <div v-else style="width: 59px; height: 33px; padding: 7px; justify-content: space-around; border-radius: 27px; gap: 5px; display: flex; align-items: center; background-color: var(--color-main);">
                                <div style="font-size: 12px; font-weight: 500; background: linear-gradient(180deg, #FFDFCA 0%, #FDAE7B 100%); border-radius: 50%; width: 17px; height: 17px; display: flex; justify-content: center; align-items: center;">P</div>
                                <div style="font-weight: 500; margin-top: 1px;">{{ each.point }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 25px;">
                <div style="font-weight: 700;">회원 등급 안내</div>
                <div style="margin-top: 15px;">
                    <div v-for="each, i in gradeList" :key="i + 'grade'" :style="{ background: setBackgroundColor(each.idx) }" style="border-radius: 12px; display: flex; height: 84px; margin-bottom: 20px; padding: 20px 12px;">
                        <div style="display: flex; align-items: center; gap: 12px; flex: 1;">
                            <div>
                                <img style="width: 40px;" :src="$resourcePath + each.image_path" alt="">
                            </div>
                            <div style="font-weight: 700;">{{ each.name }}</div>
                        </div>
                        <div style="font-weight: 500; text-align: right;">
                            <div v-if="each.idx != 4">{{ each.min_point + ' ~ ' + each.max_point + 'P' }}</div>
                            <div v-else>{{ each.min_point + 'P 이상' }}</div>
                            <div v-if="each.idx == 1" style="font-size: 12px; color: #fff; margin-top: 12px;">회원 가입 시, 기본 부여</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
// import { POINT_HISTORY_REWARD } from '@/Constants';
import moment from 'moment'

export default {
    name: 'MembershipLevel',
    components: { MercenaryHeader },
    data() {
        return {
            thisWeekAttendance: [],
            monthNumber: 0,
            weekString: '',
            today: moment().format('YYYY-MM-DD'),
            accumulationList: [],
            gradeList: [],
            totalPoint: 0,
            todayPoint: 0,
            myGradeImagePath: '',
            myGradeName: ''
        }
    },
    methods: {
        setBackgroundColor(idx) {
            if (idx == 1) {
                return '#210F038F'
            } else if (idx == 2) {
                return 'linear-gradient(90deg, #826753 0%, #D5AF91 50%, #826753 100%)'
            } else if (idx == 3) {
                return 'linear-gradient(90deg, #B5B5B5 0%, #EAEAEA 50%, #B5B5B5 100%)'
            } else {
                return 'linear-gradient(90deg, #DAAD53 0%, #FDE085 50%, #DAAD53 100%)'
            }
        },
        async getMenuList() {
            const res =  await this.$Axios.get('/api/membership/menu/list')

            const accumulationList = res.data.accumulation_list
            const grade_list = res.data.grade_list

            this.accumulationList = accumulationList
            this.accumulationList.pop()
            this.gradeList = grade_list
            this.setShoesImg()
        },
        setShoesImg() {
            const transTotalPoint = parseInt(this.totalPoint)
            if (transTotalPoint >= 0 && transTotalPoint <= 99) {
                this.myGradeImagePath = this.gradeList[0].image_path
                this.myGradeName = this.gradeList[0].name
            } else if (transTotalPoint >= 100 && transTotalPoint <= 399) {
                this.myGradeImagePath = this.gradeList[1].image_path
                this.myGradeName = this.gradeList[1].name
            } else if (transTotalPoint >= 400 && transTotalPoint <= 899) {
                this.myGradeImagePath = this.gradeList[2].image_path
                this.myGradeName = this.gradeList[2].name
            } else if (transTotalPoint >= 900) {
                this.myGradeImagePath = this.gradeList[3].image_path
                this.myGradeName = this.gradeList[3].name
            }
        },
        async getGradeInfo() {
            const res = await this.$Axios.get('/api/membership/grade_info')
            const totalPoint = res.data.point_info[0].point
            const todayPoint = res.data.point_info[0].today_point === null ? 0 : res.data.point_info[0].today_point

            this.totalPoint = totalPoint
            this.todayPoint = todayPoint

            const attendedDates = res.data.weekly_attendance.map(item => 
                moment(item.insert_date).format('YYYY-MM-DD')
            )

            this.getAttendanceList(attendedDates)
            this.getWeekOfMonth()
        },
        setBoxClass(isBeforeToday, isAttend) {
            if (isBeforeToday) {
                if (isAttend) {
                    return 'attend'
                } else {
                    return 'absence'
                }
            } else {
                return 'after'
            }
        },
        getAttendanceList(attendedDates) {
            const weekDaysKR = ['일','월','화','수','목','금','토'];
            const thisWeekAttendance = []
            const startOfWeek = moment().startOf('week').add(1, 'day')
            const today = moment().format('YYYY-MM-DD')

            for (let i = 0; i < 7; i++) {
                const current = startOfWeek.clone().add(i, 'day');
                const date = current.format('YYYY-MM-DD');
                thisWeekAttendance.push({
                    date,
                    day: weekDaysKR[current.day()],
                    isAttend: attendedDates.includes(date),
                    isBeforeToday: date <= today
                })
            }
            this.thisWeekAttendance = thisWeekAttendance
        },
        getWeekOfMonth() {
            const thisMonthNumber = moment().month() + 1;
            const today = moment();
            const startOfMonth = moment().startOf('month');
            const firstMonday = startOfMonth.clone().day(1);

            const weekOfMonth = today.diff(firstMonday, 'weeks') + 1;
            const weekNames = ["첫째", "둘째", "셋째", "넷째", "다섯째"];

            const weekString = weekNames[weekOfMonth - 1] || `${weekOfMonth}째`;
            this.monthNumber = thisMonthNumber
            this.weekString = weekString
        }
    },
    created() {
        this.getGradeInfo()
        this.getMenuList()
    }
}
</script>

<style scoped>
.common_box {
    border-radius: 3px; 
    padding: 0 8px; 
    display: flex; 
    flex-direction: column; 
    align-items: center;
    position: relative;
}

.attend {
    background-color: #C24E00;
}

.after {
    border: 1px dashed #fff;
    opacity: 0.5;
}

.absence {
    opacity: 0.2;
    background-color: #C24E00;
}
</style>